
const validateImages = async (rule, value, callback, context) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (sum < 1) {
        return callback(new Error('至少要选择1张图片'));
    }
    if(context.$refs.imagesRef){
        let errMsg = await context.$refs.imagesRef.method_validImage();
        if(errMsg){
            return callback(new Error(errMsg));
        }
    }
    return callback()
    
}
const validateItemDelivery = async (rule, value, callback, context) => {
    if(!value || value.length === 0){
        return callback(new Error('请选择物流配送'));
    }
    return callback();
}
// 若需要vm上下文请用此函数包裹
function contextWrap(fn, context) {
    return (rule, value, callback) => fn(rule, value, callback, context)
}

const RULES = function(context) {
    return {
        itemName:[
            {required: true, message: '请输入商品标题'},
        ],
        images: [
            {required: true, message: '至少选择1张图片'},
            {validator: contextWrap(validateImages, context)}
        ],
        price:[
            {required: true, message: '请填写商品价格'},
        ],
        stock:[
            {required: true, message: '请填写商品库存'},
        ],
        itemDelivery:[
            {required: true, message: '请填选择物流配送'},
            {validator: contextWrap(validateItemDelivery, context)}
        ],
        goodsDesc:[
            {required: true, message: '请输入商品描述'},
        ],
        goodsDescImage:[
            {required: true, message: '至少选择1张图片'},
        ],
    };
}


export {
    RULES as default,
}
